// const Sticky = require("sticky-js");
const FixedIn = require('../../../../js/FixedIn');
const { MAIN_EASING, DELAY_DEBOUNCE } = require('../../../../js/consts');
const {
	getNumber,
	mediaQueryMin,
	toggleMenuArias,
	setHeightFrom,
	getFocusablesFrom,
	trackGtm,
	fillWithDomElementsAll,
	trackGtm4,
} = require('util/functions');
const { stuttering, default: onWidthResize } = require('util/onWidthResize');
let { evenSlowerDelay, breakMedium } = require('util/sass-variables').default;
const asyncImport = require('util/asyncImport').default;

evenSlowerDelay = getNumber(evenSlowerDelay) * 1000;

const CLASS_CURRENT = 'current';
const CLASS_CATEGORY_MENU = 'category--menu';
const CLASS_CATEGORY_CONTAINER = 'category--container';
const CLASS_CATEGORY_LINK = 'category--link';
const CLASS_LEFT_MENU_CONTAINER = 'left-menu--container';
const CLASS_LEFT_MENU_ITEMS = 'left-menu--items';
const CLASS_LEFT_MENU_LINK = 'left-menu--link';
const CLASS_STEP_LINK = 'left-menu--step-link';
const CLASS_ENTRY = 'entry';
const CLASS_ENTRY_CONTAINER = 'entry--container';
const CLASS_ENTRY_UNFOLD = 'entry--unfold';
const CLASS_ENTRY_ANSWER = 'entry--answer';
const CLASS_FAQ_CATEGORY = 'faq--category';
const CLASS_LIST_CONTENT = 'list-content';

const selectorsAll = {
	entryUnfold: CLASS_ENTRY_UNFOLD,
};

module.exports = {
	async init() {
		await asyncImport(this, ['anime', 'throttle']);

		this.initElements();
		this.initEvents();
		this.updatePositions();
		this.scrollEvent();

		this.currentPosition = this.getCurrentIndex();
		this.fixingManager = Object.create(FixedIn);
		let fixedElement = this.isFaq
			? `.${CLASS_CATEGORY_MENU}`
			: `.${CLASS_LEFT_MENU_ITEMS}`;
		let containerElement = this.isFaq
			? `.${CLASS_CATEGORY_CONTAINER}`
			: `.${CLASS_LEFT_MENU_CONTAINER}`;
		this.fixingManager.init(
			this.root.querySelector(fixedElement),
			this.root.querySelector(containerElement),
			200,
			100,
		);
	},
	initElements() {
		// FAQ
		fillWithDomElementsAll(this, selectorsAll);
		this.entryQuestions = this.entryUnfold;

		const faqCategories = Array.from(
			this.root.querySelectorAll(`.${CLASS_FAQ_CATEGORY}`),
		);

		this.entryQuestions.forEach(question => {
			question.__focusables = getFocusablesFrom(
				question.parentNode.parentNode.querySelector(
					`.${CLASS_ENTRY_CONTAINER}`,
				),
			);
			// auto set tab indexes
			this.closeQuestion(question);
		});
		this.isFaq = !!faqCategories.length;

		// TBEJ
		const stepLinks = Array.from(
			this.root.querySelectorAll(`.${CLASS_STEP_LINK}`),
		);
		this.isTBEJourneyPresent = !!stepLinks.length;

		this.content = this.isFaq
			? faqCategories
			: Array.from(this.root.querySelectorAll(`.${CLASS_LIST_CONTENT}`));

		let menuLinksSelector;
		if (this.isFaq) {
			menuLinksSelector = `.${CLASS_CATEGORY_LINK}`;
		} else if (this.isTBEJourneyPresent) {
			menuLinksSelector = `.${CLASS_STEP_LINK}`;
		} else {
			// Cou
			menuLinksSelector = `.${CLASS_LEFT_MENU_LINK}`;
		}

		this.menuLinks = Array.from(this.root.querySelectorAll(menuLinksSelector));
	},
	initEvents() {
		// Desktop only
		if (mediaQueryMin(breakMedium)) {
			const throtteledScroll = this.throttle(this.scrollEvent.bind(this), 50);
			window.addEventListener('scroll', throtteledScroll);

			this.menuLinks.forEach((link, linkIndex) => {
				link.addEventListener('click', e => {
					this.menuClickHandler(e, linkIndex);
				});
			});
		}

		if (this.isFaq) {
			this.entryQuestions.forEach(link => {
				link.addEventListener('click', () => {
					this.toggleQuestion(link);
				});
			});
		}
		onWidthResize(
			this.updatePositions.bind(this),
			stuttering.DEBOUNCE,
			DELAY_DEBOUNCE,
		);
		onWidthResize(() => {
			// dont bother listening events for an undisplayed functionality
			this.fixingManager.activateEvents(mediaQueryMin(breakMedium));
		});
	},
	menuClickHandler(e, linkIndex) {
		e.preventDefault();
		this.clickedLinkIndex = linkIndex;
		if (this.positionsAffected) this.updatePositions();
		this.anime({
			targets: document.scrollingElement,
			scrollTop: this.positions[linkIndex],
			easing: MAIN_EASING,
			duration: evenSlowerDelay,
			begin: () => {
				this.scrolledBeforeAnim = window.scrollY;
			},
			complete: this.onAnimDone.bind(this),
		});
	},
	onAnimDone() {
		if (window.scrollY === this.scrolledBeforeAnim) {
			// No animation was performed => force link selection
			this.selectMenuLink(this.clickedLinkIndex);
		}
		this.scrolledBeforeAnim = null;
		this.clickedLinkIndex = null;
	},
	scrollEvent() {
		if (this.positionsAffected) this.updatePositions();
		const current = this.clickedLinkIndex || this.getCurrentIndex();
		this.selectMenuLink(current);
	},
	selectMenuLink(current) {
		this.menuLinks.forEach((menu, i) => {
			const headingId = decodeURIComponent(menu.href.split('#')[1]);
			const headingElement = document.getElementById(headingId);
			if (i === current) {
				menu.classList.add(CLASS_CURRENT);
				headingElement.classList.add(CLASS_CURRENT);
			} else {
				menu.classList.remove(CLASS_CURRENT);
				headingElement.classList.remove(CLASS_CURRENT);
			}
		});
	},
	getCurrentIndex() {
		const index = this.positions.findIndex(
			currentPosition => window.pageYOffset < currentPosition,
		);

		return this.limitIndex(index);
	},
	limitIndex(index) {
		if (index === -1) return this.positions.length - 1;
		return index - 1 === -1 ? 0 : index - 1;
	},
	updatePositions() {
		this.positions = this.getContentPositions();
		this.positionsAffected = false;
	},
	getContentPositions() {
		return this.content.map(
			content =>
				Math.round(content.getBoundingClientRect().top + window.pageYOffset) -
				120,
		);
	},
	toggleQuestion(target) {
		const opened = target.getAttribute('aria-expanded') === 'true';
		if (opened) this.closeQuestion(target);
		else this.openQuestion(target);
		this.positionsAffected = true;
		if (opened) {
			this.gtmTracking(false, target);
		} else {
			this.gtmTracking(true, target);
		}
	},
	gtmTracking(expend, button) {
		trackGtm({
			eventCategory: `${button.dataset.category}`,
			eventAction: `${expend ? 'expand' : 'collapse'}`,
			eventLabel: `${button.innerHTML}`,
		});
		trackGtm4({
			event: 'GA4_event_c_faq_click',
			widget_name: 'V3-Faq',
			faq_question: button.innerHTML.trim(),
			faq_section: button.dataset.category,
			interaction_type: `${expend ? 'show more' : 'show less'}`,
		});
	},
	closeQuestion(target) {
		toggleMenuArias(target, target.__focusables, false);
		const grandParent = target.closest(`.${CLASS_ENTRY}`);
		const container = grandParent.querySelector(`.${CLASS_ENTRY_CONTAINER}`);
		container.style.height = 0;
	},
	openQuestion(target) {
		toggleMenuArias(target, target.__focusables, true);
		const grandParent = target.closest(`.${CLASS_ENTRY}`);
		const container = grandParent.querySelector(`.${CLASS_ENTRY_CONTAINER}`);
		const answer = container.querySelector(`.${CLASS_ENTRY_ANSWER}`);
		setHeightFrom(container, answer);
	},
};
